import { render, staticRenderFns } from "./goods-columns.vue?vue&type=template&id=a0485d18&scoped=true&"
import script from "./goods-columns.vue?vue&type=script&lang=js&"
export * from "./goods-columns.vue?vue&type=script&lang=js&"
import style0 from "./goods-columns.vue?vue&type=style&index=0&id=a0485d18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0485d18",
  null
  
)

export default component.exports